import React from 'react';
import classnames from 'classnames';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import { Site } from 'four-nets/site';
import photo from 'four-nets/icons/svg/icon_photo.svg';

import defaultStyles from './inspiration-info.scss';


export interface Props {
    id: string;
    imagesCount: number | null;
    styles: typeof defaultStyles;
}

class InspirationInfo extends React.PureComponent<Props, {}> {
    static contextTypes = {
        site: PropTypes.instanceOf(Site),
    };

    render() {
        const { styles, imagesCount } = this.props;
        return (
            <div className={styles.info}>
                <Link to='/inspirations/' className={classnames(styles.infoItem, styles.mainItem)}>
                    <FormattedMessage id='INSPIRATION' />
                </Link>
                <span className={styles.infoItem}>
                    <SVGIcon style={{image: styles.infoIcon}} src={photo} />
                    {imagesCount}
                </span>
            </div>
        );
    }
}

export default Styled(defaultStyles)(InspirationInfo);
